export const FETCH_ADMINPERMISSIONS_BEGIN="FETCH_ADMINPERMISSIONS_BEGIN";
export const FETCH_ADMINPERMISSIONSTENANT_SUCCESS="FETCH_ADMINPERMISSIONSTENANT_SUCCESS";
export const FETCH_ADMINPERMISSIONS_FAILURE="FETCH_ADMINPERMISSIONS_FAILURE";   

export const FETCH_ADMINTHEMES_BEGIN="FETCH_ADMINTHEMES_BEGIN";
export const FETCH_ADMINTHEMELIST_SUCCESS="FETCH_ADMINTHEMELIST_SUCCESS";
export const FETCH_ADMINTHEME_SUCCESS="FETCH_ADMINTHEME_SUCCESS";
export const FETCH_ADMINREPORT_SUCCESS="FETCH_ADMINREPORT_SUCCESS";
export const FETCH_ADMINREPORTPART_SUCCESS="FETCH_ADMINREPORTPART_SUCCESS";
export const FETCH_ADMINREPORTPARTLIST_SUCCESS="FETCH_ADMINREPORTPARTLIST_SUCCESS";
export const FETCH_ADMINTHEMEDETAILS_SUCCESS="FETCH_ADMINTHEMEDETAILS_SUCCESS";
export const FETCH_ADMINTHEMES_FAILURE="FETCH_ADMINTHEMES_FAILURE";   